import React, { useEffect, useState } from "react";
import MenuTitle from "../../../Components/MenuTitlle/MenuTitle";
import { getFactureListApi } from "../../../Api/BarestSupplierServices";
import { errorToast } from "../../../Utils/Toast/Toast";
import Style from "./FactureList.module.css";
import { separate } from './../../../Functions/NumberSeprator';
import { factureStatus } from "../../../Functions/FactureStatus";
import { convertDateToJalaliHandler } from "../../../Functions/convertDateToJalali";
const FactureList = () => {
  const [facturelistState, setFactureListState] = useState();
  useEffect(() => {
    getFactureListHandler();
  }, []);
  const getFactureListHandler = () => {
    getFactureListApi((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setFactureListState(res.facture);
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res.message);
      }
    });
  };
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <MenuTitle title={"لیست فاکتور های ایجاد شده"} />
      <ul className={Style.ListHolder}>
        {facturelistState?.map((item) => (
          <li className={Style.ItemHolder} key={item.id}>
            <div className={Style.ItemInfo}>
              <span>شناسه:</span>
              <p>{item.id}</p>
            </div>
            <div className={Style.ItemInfo}>
              <span>مبلغ:</span>
              <p style={{color:"green"}}>{separate(item.amount)} تومان</p>
            </div>
            <div className={Style.ItemInfo}>
              <span>وضعیت:</span>
              <p style={{color:"rgb(155, 0, 90)"}}>{factureStatus(item.status)}</p>
            </div>
            <div className={Style.ItemInfo}>
              <span>تاریخ ایجاد:</span>
              <p style={{color:"rgb(0, 111, 155)"}}>{convertDateToJalaliHandler(item.date)}</p>
            </div>
            {item?.description&&<div className={Style.ItemInfoDesctiption}>
              <span> توضیحات:</span>
              <p style={{color:"rgb(0, 111, 155)"}}>{item?.description}</p>
            </div>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FactureList;
